// extracted by mini-css-extract-plugin
export default {"progressBar":"ProgressBar_progressBar__pzTlB","bar":"ProgressBar_bar__7Zc8z","green":"ProgressBar_green__EjLtO","orange":"ProgressBar_orange__xPTYS","red":"ProgressBar_red__re9R9"};